<template>
<picker-dialog ref="dialog" :dialog-props="{'max-width': '400px'}">
  <template #default="{cancel, submit}">
    <v-card>
      <v-card-title>
        Select User Below
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="text-center">
            <v-autocomplete
              v-model="user"
              hide-no-data
              hide-selected
              placehodler="Start typing to search..."
              :items="users"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="darken-1"
          @click="cancel"
        >Cancel</v-btn>
        <v-btn
          text
          color="success darken-1"
          @click="submit(user)"
        >Done</v-btn>
      </v-card-actions>
    </v-card>
  </template>
</picker-dialog>
</template>

<script>
import PickerDialog from "@/components/search/dialogs/PickerDialog"

export default {
  name: "UserPicker",
  components: {
    PickerDialog,
  },
  data() {
    return {
      user: "",
      users: [],
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.users = (await this.httpClient.loadAllUsers()).map(u => u.name)
    },
    pop() {
      return this.$refs.dialog.pop()
    },
  },
}
</script>
